import { render, staticRenderFns } from "./NewsflashJaBatchReview.vue?vue&type=template&id=8544ec94&scoped=true&"
import script from "./NewsflashJaBatchReview.vue?vue&type=script&lang=js&"
export * from "./NewsflashJaBatchReview.vue?vue&type=script&lang=js&"
import style0 from "./NewsflashJaBatchReview.vue?vue&type=style&index=0&id=8544ec94&prod&lang=scss&scoped=true&"
import style1 from "./NewsflashJaBatchReview.vue?vue&type=style&index=1&id=8544ec94&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8544ec94",
  null
  
)

export default component.exports